(function () {
  document.documentElement.classList.add('js');

  // Mobile menu
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-menu-toggle]');
    if (!btn) return;
    var nav = document.getElementById(btn.getAttribute('aria-controls'));
    if (!nav) return;
    var open = nav.classList.toggle('is-open');
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    btn.querySelector('[data-icon-open]').hidden = open;
    btn.querySelector('[data-icon-close]').hidden = !open;
  });

  // Prefill "Tjänst" from ?tjanst=… (links like /pages/offert?tjanst=Golvvärme)
  function prefill() {
    var params = new URLSearchParams(window.location.search);
    var value = params.get('tjanst');
    if (!value) return;
    document.querySelectorAll('select[data-service-select]').forEach(function (select) {
      var match = Array.prototype.find.call(select.options, function (o) {
        return o.value === value || o.text === value;
      });
      if (!match) {
        match = new Option(value, value);
        select.add(match, select.options[1] || null);
      }
      select.value = match.value;
    });
  }

  // Scroll reveal
  function reveal() {
    var items = document.querySelectorAll('.reveal');
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    items.forEach(function (el) { io.observe(el); });
  }

  // Mark current nav item
  function currentNav() {
    var path = window.location.pathname.replace(/\/$/, '') || '/';
    document.querySelectorAll('.nav a, .mobile-nav a').forEach(function (a) {
      var href = (a.getAttribute('href') || '').split('?')[0].replace(/\/$/, '') || '/';
      if (href === path) a.setAttribute('aria-current', 'page');
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    prefill();
    reveal();
    currentNav();
  });
})();
